import { accordion } from './modules/accordion';
accordion();



